export const experiences = [
  {
    jobTitle: "Senior Software Engineer",
    company: "Qlik",
    date: "December 2022 - Present",
    skills: ["React.js", "clojure", "python", "HTML", "SQL", "SCSS/SASS"],
    summary: "Tech lead on a scalable full-stack SPA, setting technical direction and mentoring engineers across product and design.",
    jobs: [
      "Tech lead on large and complex full-stack projects, responsible for managing expectations for the product team and assisting/mentoring junior employees",
      "Led software development initiative as subject matter expert and primary point-of-contact for project management staff",
      "Orchestrated efficient large-scale software deployments. Designed, built, and maintained MySQL/Postgres databases",
      "Worked closely with design and product teams to ensure accurate rendering of App views and components",
      "Revised, modularized, and updated old bases to modern development standards, reducing operating costs and improving functionality",
      "Built a maintainable, and scalable SPA with HTML, SCSS, Javascript/React, and Clojure",
      "Prepared and submitted reports and other documentation to assist development team members"
    ]
  },
  {
    jobTitle: "Software Engineer",
    company: "Stitch/Talend",
    date: "September 2019 - December 2022",
    skills: ["React.js", "clojure", "python", "HTML", "SQL", "SCSS/SASS"],
    summary: "Owned features end-to-end and helped build a strong quality culture through testing and thorough code review.",
    jobs: [
      "Engaged in the entire software development lifecycle, encompassing requirements analysis, design, coding, testing, and deployment",
      "Troubleshot and debugged software issues proficiently, employing systematic approaches to identify root causes and implement robust solutions",
      "Conducted thorough reviews, providing constructive feedback to team members and fostering a culture of quality and collaboration",
      "Applied rigorous testing methodologies, including unit tests and integration testing, to ensure software functionality, reliability, and user satisfaction"
    ]
  },
  {
    jobTitle: "Front End Engineer",
    company: "Stitch/Talend",
    date: "April 2019 - September 2019",
    skills: ["CSS/SCSS/SASS", "javascript", "Ruby on Rails", "HTML", "Contentful", "photoshop/illustrator", ],
    summary: "Sole developer on the marketing site, shipping fast, responsive, on-brand experiences across every device.",
    jobs: [
      "Created visually captivating and user-friendly marketing websites by applying expert knowledge of CSS and web design principles, ensuring optimal user experience and engagement",
      "Collaborated closely with marketing teams and stakeholders to understand project requirements, translating them into impactful website designs that align with brand guidelines and objectives",
      "Developed and implemented responsive CSS stylesheets, delivering seamless and consistent website experiences across various devices and screen sizes"
    ]
  },
  {
    jobTitle: "Web Developer",
    company: "Freelance",
    date: "February 2013 - April 2019",
    skills: ["wordpress", "javascript", "HTML", "PHP", "SCSS/SASS"],
    summary: "Delivered custom, responsive websites for clients across diverse industries, from design through launch.",
    jobs: [
      "Developed and maintained user-facing websites through HTML, CSS, and JavaScript",
      "Optimized websites for maximum speed and scalability",
      "Utilized libraries such as jQuery and Bootstrap for rapid development",
      "Integrated third-party APIs into applications for improved functionality"
    ]
  }

]

export const skills =
  ["javascript", "clojure", "python", "AI / LLMs", "Prompt engineering", "AI-assisted development", "SASS/SCSS/CSS", "Git", "React.js", "Redux", "Docker", "Kubernetes", "typescript", "MySQL", "AWS", "PostgreSQL", "Node.js", "Photoshop/Illustrator", "Enzyme/Jest", "Ruby on Rails"];
